import * as React from 'react'

import { cn } from '@/utils/index'

const Kbd = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex h-5 min-w-5 select-none items-center justify-center rounded bg-muted px-1.5 font-sans text-xs font-medium leading-none text-muted-foreground',
        className
      )}
      {...props}
    />
  )
)

Kbd.displayName = 'Kbd'

export { Kbd }
